import type { FormValues } from "@/widgets/classic-form/form";
import {
    getEventsDetails,
    getFamilyMemberDetails,
    getGenderDetails,
    getNameDetails,
} from "@/features/tree-person-transform";
import type { FormMetadataResponse } from "@/entities/form-metadata";
import type { Person } from "@/entities/tree-person";

export const transformPersonToFormValues = (
    person: Person,
    currentFormValue: FormValues,
    formMetadata: FormMetadataResponse,
): FormValues => ({
    ...currentFormValue,
    name: getNameDetails(person, formMetadata),
    family: getFamilyMemberDetails(person.FamilyMembers, currentFormValue, formMetadata),
    events: getEventsDetails(person.LifeEvents, currentFormValue, formMetadata),
    fields: getGenderDetails(person, currentFormValue, formMetadata),
    treePerson: {
        personId: person.PersonId,
        treeId: person.TreeId,
    },
});
